export interface IAppStateType {
    name: string,
    published: boolean,
    helloMsg: string,
    byeMsg: string
    helloImg: string | null
}

interface IContentFileType {
    name: string,
    link: string
}

export interface IIndexStateType {
    id: string,
    term_id: string,
    version: string,
    files: Array<IContentFileType> | null,
    content: string
}

export interface IRootState {
    app: IAppStateType,
    index: IIndexStateType,
    router: any
}


export enum UpdateDataPaths {
    helloImg = 'helloImg',
    loadingHelloImg = '_state.isLoadingHelloImg',
    helloMsg = 'helloMsg',
    byeMsg = 'byeMsg',
    published = 'published',
}
